module.exports = __webpack_public_path__ + "img/brand2.078dfca9.png";